import React, { useState, useContext } from "react";
import { AppContext } from "../context";
import Navbar from "./Navbar";

const Liberty = () => {
  const {
    skipStencil,
    setSkipStencil,
    alignStencil,
    setalignStencil,
    capturedStencil,
    setcapturedStencil,
    stepCovered,
    setStepCovered,
    setScreen,
    currentBlock,
    condition,
    setCondition,
    config,
    token,
    mandatory,
    setMandatory,
    inspectionId,
    setStopPing,
    setCurrentPage,
    stopPing,
    restrictUserIfallNotGreen,
    setRestrictUserIfallNotGreen,
    clientId,
    caseId,
    isIOS,
    inputMetaData,
  } = useContext(AppContext);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleProceed = () => {
    if (acceptedTerms) {
      if (config["email"]) {
        setScreen("email");
      } else {
        setScreen("instructions");
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100dvh",
        width: "100dvw",
      }}
    >
      <Navbar />
      <div className="mobile-container">
        {/* Header Section */}
        <div className="header">
          <h2 className="page-title">Claim Details</h2>
        </div>
        {/* Claim Info Section */}
        <div className="section row-split border-bottom">
          <div className="field">
            <span className="label">Claim Number:</span>
            <span className="value">{inputMetaData?.claim_number || "--"}</span>
          </div>
          <div className="field">
            <span className="label">Intimation Date:</span>
            <span className="value">
              {inputMetaData?.intimation_date || "--"}
            </span>
          </div>
        </div>
        
        <div className="grid-row" style={{margin: "0px"}}>
          <div className="field">
            <span className="label">Policy Number:</span>
            <span className="value center-text">
              {inputMetaData?.policy_number || "--"}
            </span>
          </div>
        </div>
        {/* Vehicle Section */}
        <div className="spacer"></div>
        <div className="section border-bottom">
          <span className="label section-label">Vehicle</span>

          <div className="grid-row">
            <div className="field">
              <span className="label">Manufacturer:</span>
              <span className="value center-text">
                {inputMetaData?.manufacturer_name || "--"}
              </span>
            </div>
            <div className="field">
              <span className="label">Model:</span>
              <span className="value center-text">
                {inputMetaData?.model || "--"}
              </span>
            </div>
            <div className="field">
              <span className="label">Variant:</span>
              <span className="value center-text">
                {inputMetaData?.variant || "--"}
              </span>
            </div>
          </div>
          {/* Gap requested between Manufacturer row and Year of Registration */}
          <div className="spacer"></div>
          <div className="grid-row">
            <div className="field">
              <span className="label">Registration No:</span>
              <span className="value center-text">
                {inputMetaData?.vehicle_number || "--"}
              </span>
            </div>
            <div className="field">
              <span className="label">Year of Registration:</span>
              <span className="value center-text">
                {inputMetaData?.year_of_manufacture || "--"}
              </span>
            </div>
          </div>
        </div>
        {/* Insured Section */}
        <div className="section border-bottom">
          <div className="field">
            <span className="label section-label">Insured</span>
            <span className="value main-text">
              {inputMetaData?.insured_name || "--"}
            </span>
          </div>
        </div>
        {/* Terms and Conditions */}
        <div className="terms-section">
          <input
            type="checkbox"
            id="termsCheckbox"
            className="checkbox"
            checked={acceptedTerms}
            onChange={(e) => setAcceptedTerms(e.target.checked)}
          />
          <label htmlFor="termsCheckbox" className="terms-label">
            I have read and agree the Terms of Service and Privacy Policy.
          </label>
        </div>
        {/* Action Button */}
        <div className="footer">
          <div className="footerDiv">
            <button
              className={`proceed-btn ${acceptedTerms ? "active" : "disabled"}`}
              onClick={handleProceed}
              disabled={!acceptedTerms}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Liberty;
